import authHelper from "@/helpers/auth";
import apiAuth from "@/api/auth";

const defaultState = () => ({
  isAuth: authHelper.loggedIn(),
  isAttempting: false,
  alerts: {},
  fieldErrors: {},
  alertMultiple: [],
  userData: authHelper.getUserData(),
  accountList: authHelper.getListAccount()
});

const state = defaultState();

const getters = {
  isAuth(state) {
    return state.isAuth;
  }
};

const mutations = {
  attempting(state) {
    state.isAttempting = true;
    state.fieldErrors = {};
    state.alerts = [];
  },
  attempted(state) {
    state.isAttempting = false;
  },
  failed(state, data) {
    state.alerts = {
      show: true,
      message: data.message
    };
  },
  validationError(state, errors) {
    state.fieldErrors = errors;
  },
  multipleAlert(state, data) {
    state.alertMultiple = data.map(el => {
      return {
        show: true,
        message: el
      };
    });
  },
  setProfileData(state, data) {
    authHelper.setProfileData(data);
    state.userData = authHelper.getUserData();
    state.isAuth = true;
    state.fieldErrors = {};
    state.alerts = [];
  },
  setImageData(state, data) {
    authHelper.setImageData(data);
    state.userData = authHelper.getUserData();
    state.isAuth = true;
    state.fieldErrors = {};
    state.alerts = [];
  },
  saveListAccount(state, data) {
    authHelper.setListAccount(data);
    state.accountList = authHelper.getListAccount();
  },
  success(state, authData) {
    authHelper.setData(authData);
    state.userData = authHelper.getUserData();
    state.isAuth = true;
    state.fieldErrors = {};
    state.alerts = [];
  },
  removeAlert(state, id) {
    const index = Array.from(state.alerts).findIndex(it => it.id === id);

    if (index !== -1) {
      state.alerts.splice(index, 1);
    }
  },
  clearData(state) {
    state.isAuth = false;
    authHelper.clearData();
    state.userData = authHelper.getUserData();
    state.accountList = authHelper.getListAccount();
  },
  reset(state) {
    Object.assign(state, defaultState());
  }
};

const actions = {
  login({ commit, dispatch }, { username, password }) {
    return new Promise(resolve => {
      commit("attempting");
      apiAuth
        .login(username, password)
        .then(({ data: { data } }) => {
          resolve(data.results);
        })
        .catch(err => {
          const { data } = err.response;
          dispatch("errorHandler", data);
        })
        .then(() => {
          commit("attempted");
        });
    });
  },
  loginJwt({ commit, dispatch }, { token }) {
    return new Promise(resolve => {
      commit("attempting");
      apiAuth
        .loginJwt(token)
        .then(({ data: { data } }) => {
          resolve(data.results);
        })
        .catch(err => {
          const { data } = err.response;
          dispatch("errorHandler", data);
        })
        .then(() => {
          commit("attempted");
        });
    });
  },
  loginsso({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      commit("attempting");
      apiAuth
        .loginsso(params)
        .then(({ data: { data } }) => {
          commit("success", data);
          resolve(true);
          commit("attempted");
        })
        .catch(err => {
          const { data } = err.response;
          dispatch("errorHandler", data);
          reject(data);
        });
    });
  },
  register({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      commit("attempting");
      apiAuth
        .register(params)
        .then(() => {
          resolve(true);
        })
        .catch(err => {
          reject(true);
          const { data } = err.response;
          dispatch("errorHandler", data);
        })
        .then(() => {
          commit("attempted");
        });
    });
  },
  forgetPassword({ commit, dispatch }, { mobilephone, email }) {
    return new Promise((resolve, reject) => {
      commit("attempting");
      apiAuth
        .forgetPassword(mobilephone, email)
        .then(({ data }) => {
          commit(
            "makeAlert",
            { code: "success", type: "success", message: data.message, show: true },
            { root: true }
          );
          resolve(true);
        })
        .catch(err => {
          const { data } = err.response;
          dispatch("errorHandler", data);
          reject(data);
        })
        .then(() => {
          commit("attempted");
        });
    });
  },
  confirmNewPassword({ commit, dispatch }, { token, password, repassword }) {
    return new Promise((resolve, reject) => {
      commit("attempting");
      apiAuth
        .confirmNewPassword(token, password, repassword)
        .then(({ data }) => {
          commit(
            "makeAlert",
            { code: "success", type: "success", message: data.message, show: true },
            { root: true }
          );
          resolve(true);
        })
        .catch(err => {
          const { data } = err.response;
          dispatch("errorHandler", data);
          reject(data);
        })
        .then(() => {
          commit("attempted");
        });
    });
  },
  verifyToken({ commit, dispatch }, { token }) {
    return new Promise((resolve, reject) => {
      commit("attempting");
      apiAuth
        .verifyToken(token)
        .then(() => {
          resolve(true);
          commit("attempted");
        })
        .catch(err => {
          const { data } = err.response;
          dispatch("errorHandler", data);
          reject(data);
        });
    });
  },
  logout({ commit }) {
    commit("clearData");

    return Promise.resolve(true);
  },
  errorHandler({ commit }, response) {
    switch (response.message) {
      case "error_validation":
        commit("validationError", response.data);
        break;

      case "multiple_alert":
        commit("multipleAlert", response.data);
        break;

      default:
        commit("failed", { code: "error_response", type: "error", message: response.message });
        break;
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
